import React, { Component } from 'react'
import 'antd/dist/antd.css'
import '../../style/contact.css'
import email from 'emailjs'
import { Form, Icon, Input, Button, message } from 'antd';
import contact from '../../images/contact.png'
import axios from 'axios'
import { Alert } from 'antd'
const { TextArea } = Input;

class Contact extends Component {
    state = {success:false, fail:false}
    componentDidMount() {
        console.log(this.props.form)
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                message.error('Fill all fields');
                console.log(err)
            } else {
                axios.post('https://formspree.io/mwkrzpyl', {
                    data: values
                })
                    .then(function (response) {
                        console.log(response);
                        if(response.status == 200) {
                            this.setState({
                                success:true
                            })
                        }
                    }.bind(this))
                    .catch(function (error) {
                        this.setState({
                            fail:true
                        })
                        console.log(error);
                    });
                console.log('Received values of form: ', values);
            }

        });
    };



    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;
        // Only show error after a field is touched.
        const nameError = isFieldTouched('name') && getFieldError('name');
        const emailError = isFieldTouched('email') && getFieldError('email');
        const messageError = isFieldTouched('message') && getFieldError('message');
        return (
            <div>
                <center style={{ marginTop: "5%" }}>
                    <h2>
                        Contatct Me
                    </h2>
                </center>
                <div className="contact_body">
                    <div className="image_body">
                        <img height="100%" width="100%" src={contact}></img>
                    </div>
                    <div className="form_body">
                        <br></br><br></br><br></br><br></br>
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Item validateStatus={emailError ? 'error' : ''} help={emailError || ''}>
                                {getFieldDecorator('email', {
                                    rules: [{ required: true, message: 'Please input your email!' }],
                                })(
                                    <Input
                                        prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="Your Email"
                                    />,
                                )}
                            </Form.Item>
                            <br />
                            <Form.Item validateStatus={messageError ? 'error' : ''} help={messageError || ''}>
                                {getFieldDecorator('message', {
                                    rules: [{ required: true, message: 'Please input your message!' }],
                                })(
                                    <TextArea
                                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="Your Message"
                                        rows={8}
                                    />,
                                )}
                            </Form.Item>
                            <br />
                            <Form.Item>
                                <Button type="primary" htmlType="submit">
                                    Send Mail
          </Button>
                            </Form.Item>
                        </Form>
                        {this.state.success && <Alert message="Message sent" type="success" />}
                        {this.state.fail && <Alert message="Failed to send" type="error" />}
                    </div>
                </div>
                <br /><br /><br /><br />
            </div>
        );
    }
}

const WrappedHorizontalLoginForm = Form.create({ name: 'horizontal_login' })(Contact);

export default WrappedHorizontalLoginForm